import React from 'react';

import Chip from '../Chip';
import { StrategyChangeStatus } from '~/api-services/AIStrategyBuilderService/types';
import { statusChangeLabel, statusColor } from '~/constants/strategyConstants';
import { useTheme } from '~/hooks/useTheme';

type Props = {
    status: StrategyChangeStatus;
    size?: 'sm' | 'md';
    serverLabel?: string;
};

export default function StatusChip({ status, size = 'sm', serverLabel }: Props) {
    const theme = useTheme();

    return <Chip label={statusChangeLabel(status, serverLabel)} color={statusColor(theme, status)} size={size} />;
}
